<template>
  <div>
    <div class="home">
      <van-nav-bar title="合作伙伴" left-text="返回" @click-left="onClickLeft" fixed/>
      <div class="navheight"></div>
      <div class="content">
        <div class="nongmu_cont">
          <div class="contentTie">
            <img src="../../assets/joinusimg/companylogo/jinghaiqinye.png" alt="">
            <div class="company">江苏京海禽业集团有限公司</div>
          </div>
          <div class="labInfo">
            <span>京海</span>
            <span>肉鸡</span>
            <span>黄鸡</span>
            <span>绿色</span>
            <span>环保</span>
          </div>
          <div class="companyInfo">
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/jinghaiqinye1@3x.png" alt="">
            <div class="companyWord">江苏京海禽业集团有限公司一家专业从事种禽繁育、肉鸡饲养，饲料生产、绿色食品开发、有机肥生产和病死畜禽无害化处理等为一体的科技型农牧企业。公司年产白羽父母代种雏800万套、商品雏1亿只、“京海黄鸡”苗鸡1000万只、生态饲料8万吨、屠宰加工肉鸡2000万只。所产种雏、商品雏远销全国26个省、市、自治区，联结带动8.3万农户共同走上养鸡致富道路，年产生社会效益数十亿元，产业规模列同行江苏第一、全国第四。企业先后被国家八部委认定为“农业产业化国家重点龙头企业”和“全国农业产业化优秀龙头企业”，企业拥有动植物新品种权2项，各类专利26项，发表专业论文351篇，出版国家级刊物专著2本，发布江苏省地方标准6项、行业标准1项，荣获国家科技进步二等奖1项、省部级科技进步一等奖4项，是全国家禽行业公认的科技型领军企业。</div>
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/jinghaiqinye2@3x.png" alt="">
            <img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/jinghaiqinye3@3x.png" alt="">
          </div>
        </div>
      </div>
      <div class='bottom'>
        <div class="title">经营范围</div>
          <div class="info"> 家禽饲养销售、孵化；饲料；农副产品；生物有机肥料等</div>
      </div>
      <footer class="nongmu-footer">
        <dl>
          <dt><img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/wangzhi@3x.png" alt=""></dt>
          <dd><a href="http://www.jinghai.net/">http://www.jinghai.net/</a></dd>
        </dl>
        <dl>
          <dt><img src="https://zkjy.oss-cn-beijing.aliyuncs.com/zkjyh5/zhjyhz/partnerimg/dizhi@3x.png" alt=""></dt>
          <dd>江苏省海门市人民东路380号 </dd>
        </dl>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'partner',
  methods: {
    onClickLeft() {
      this.$router.back(-1)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/style/partner.scss';
</style>
